import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { AlertService } from './alert.service';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class RoutesService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private alertService: AlertService
  ) { }

  getRoutes_rol(userName): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRoutes/' + userName + '/' + this.commonService.getUserRole();
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
    .toPromise()
    .then(response => {
      // console.log('response : ', response)
      // const response = JSON.parse(obj.toString());
      return response;
      // if ( response && response['status'] && response['status'] === 'EXITO' ) {
      //   console.log('response : ', response)
      //   return response;
      // } else {
      //   if (response && response['status'] === 'ERROR') {
      //     this.alertService.error(response['message']);
      //   }
      });
  }

  getRoutes(userName): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRoutes/' + userName
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
    .toPromise()
    .then(response => {
      // console.log('response : ', response)
      // const response = JSON.parse(obj.toString());
      return response;
      // if ( response && response['status'] && response['status'] === 'EXITO' ) {
      //   console.log('response : ', response)
      //   return response;
      // } else {
      //   if (response && response['status'] === 'ERROR') {
      //     this.alertService.error(response['message']);
      //   }
      });
  }

  getAllRfids(): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRfids_account/' + this.commonService.getUserName();
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        console.log(response)
        return response;
    });
  }

  getRoutesByUsername(userName): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRoutes1_rol/' + userName + "/" + this.commonService.getUserRole();
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
    .toPromise()
    .then(obj => {
      const response = JSON.parse(obj.toString());
      return response;
      });
  }

  getRoutesInformation(routesId): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRouteInformation/' + routesId;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
    .toPromise()
    .then(obj => {
      const response = JSON.parse(obj.toString());
      return response;
      });
  }

  saveRoutesService(name, description, code, time, Distance, Forward_or_Back, username): Promise<any> {
    const values = new Object({
                            'Name': name,
                            'Description': description, 
                            'Divipol_code': code, 
                            "Time" : time, 
                            'User_account': username, 
                            "Distance" : Distance,
                            "Forward_or_back" : Forward_or_Back
                          });
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/insertRoute',
    JSON.stringify(values), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(response => {
        return response;
      });
  }

  saveRfids(paramsRfid): Promise<any> {
     return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/insertRfid',
      JSON.stringify(paramsRfid), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(response => {
      return response;
      });
  }

  deleteRfid(idRfid: any): Promise<any> {
    console.log('eliminando rfid');
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/deleteRfids/' + idRfid;
    return this.http.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; ; charset=UTF-8'
      }
    })
      .toPromise()
      .then(response => {
        console.log('response delete : ', response)
        /*if (response && response['message']) {
          this.alertService.success(response['message']);
        } else {
          this.alertService.error('error');
        }*/
        return response;
      });
  }

  getDrivers_withFilters(userAccount, codes, names, status, rfids, dispatchers): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getRoutes_filters';

    var data = {
      user_account : userAccount, 
      codes : codes, 
      names : names, 
      status : status, 
      rfids : rfids, 
      dispatchers : dispatchers
    }

    return this.http.post(url, data
                ,{headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = obj;
        return response;
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/routes.service.ts